import React from 'react';
import { Link, useParams } from 'react-router';
import { Descriptions, Spin } from 'antd';
import { PageMeta } from '@app/components/meta/Meta';
import { PageHeader } from '@app/components/page/PageHeader';
import { PageTitle } from '@app/components/page/PageTitle';
import { PageLayout } from '@app/components/page';
import { BackButton } from '@app/components/back-button/BackButton';
import useUser from '@app/hooks/users/useUser';
import { url } from '@app/utils/constants';

export const UserView = () => {
    const params = useParams();
    const userId = params.id?.toString() || '';
    // Fetch data from the API
    const { data: user, isPending } = useUser({
        id: userId,
    });

    const items = [
        {
            label: 'First Name',
            children: user?.first_name,
        },
        {
            label: 'Last Name',
            children: user?.last_name,
        },
        {
            label: 'Email',
            children: user?.email,
        },
        {
            label: 'Phone',
            children: user?.telephone,
        },
        // {
        //     label: 'Address',
        //     children: [
        //         user?.address?.address,
        //         user?.address?.city,
        //         user?.address?.state,
        //         user?.address?.postalCode,
        //         user?.address?.country,
        //     ]
        //         .filter(Boolean)
        //         .join(', '),
        // },
    ];

    const userName = [user?.first_name, user?.last_name].filter(Boolean).join(' ') || 'View User';

    return (
        <React.Fragment>
            <PageMeta title="View User" />
            <PageHeader
                breadcrumbItems={[
                    { title: <Link to={url.adminPortal.dashboard}>Dashboard</Link> },
                    { title: <Link to={url.adminPortal.users.list}>Users</Link> },
                    { title: userName },
                ]}>
                <PageTitle title="User Details" prepend={<BackButton />} />
            </PageHeader>
            <PageLayout>
                <PageLayout.Content>
                    <Spin spinning={isPending}>
                        <Descriptions bordered items={items} layout="horizontal" column={1} />
                    </Spin>
                </PageLayout.Content>
            </PageLayout>
        </React.Fragment>
    );
};

export default UserView;
